export default __webpack_public_path__ + "static/media/NatExpEastCoast.8e738b53.webp";